<div class="grid-container xl-max:w-full" style="height: 100vh">
  <div class="w-full h-full flex flex-row justify-center items-center">
    <tandem-loading-container [isLoaded]="false"></tandem-loading-container>
  </div>
</div>
